<form [formGroup]="frm_bill_type" (ngSubmit)="onSubmit(frm_bill_type.value)">
    <div class="modal-body">
        <div class="row pt-0">
            <div class="form-group col-md-6" >
                <h6>Bill Type Name<span class="text-danger">*</span>:</h6>
                <input formControlName="name" class="form-control form-control-sm" type="text" required>
                <div *ngIf="frm_bill_type.controls.name.touched">
                    <div *ngIf="frm_bill_type.controls.name.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div> 
            </div>
            <div class="col-md-6">
                <h6>Description<span class="text-danger">*</span>:</h6>
                <input formControlName="description" class="form-control form-control-sm" type="text" required>
                <div *ngIf="frm_bill_type.controls.description.touched">
                    <div *ngIf="frm_bill_type.controls.description.errors?.required">
                        <small class="text-danger" >This field is required.</small>
                    </div>
                </div> 
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="submit" class="btn btn-sm btn-success" [disabled]="!frm_bill_type.valid || spinner == true">Save</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()" >Cancel</button>
    </div>
</form>